import { useEffect, useState } from "react";
import { UserService } from "../../service/UserService"
import { useNavigate } from "react-router-dom";
import { AuthService } from "../../service/AuthService";
import { Backdrop } from "@mui/material";
import Loader from "../Loader";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { type } from "@testing-library/user-event/dist/type";
import { EventCredentialsSevice } from "../../service/EventCredentialsService";

function LoginForm() {
  const navigate = useNavigate();
  const [openLoader, setopenLoader] =useState(false);
  const [passwordVisible, setPasswordVisible]= useState(false);
  const [currentSecond, setCurrentSecond]= useState('')

  const handleLogin = async (e) => {
    e.preventDefault();

    const passwordType = "password_"+currentSecond;
    const username = document.getElementById('username').value;
    const password = document.getElementById('password').value;

    try {
      setopenLoader(true)
      //  const result = await AuthService.LoginUser(username, password, userTypeID);
      const result = await AuthService.LoginEventUser(username, password, passwordType);
      if (result.isSuccess) {
        // console.log(result);
        navigate('/eventlist');
        setopenLoader(false)
      } else {
        alert(result.message)
        setopenLoader(false)
      }
    } catch (error) {
      setopenLoader(false)
    } finally {
    }
  }

  function getCurrentSecond(){
    let second= new Date().getSeconds();
    setCurrentSecond(second%10)
  }

  useEffect(()=>{
    getCurrentSecond();
  },[])
 
  return (
    <>
    <Backdrop
                sx={{ color: '#FF5C35', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={openLoader} >
                    <Loader/>
    </Backdrop>
    <div className="w-full h-[90vh] flex justify-center overflow-hidden items-center">
      <div className="md:p-10 p-5 lg:w-[30%]  w-[80%] shadow-sm shadow-gray-500 rounded-xl ">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <h2 className=" text-center max-sm:text-lg max-md:text-xl text-2xl font-bold leading-9 tracking-tight text-gray-900">
            Sign in to your account [<span className="text-orange-600">{currentSecond}</span>]
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm ">
          <form className="space-y-6" onSubmit={(e) => handleLogin(e)}>
            <div className="max-sm:mx-2">
              <label className="block text-start text-sm font-medium leading-6 text-gray-900">
                Username
              </label>
              <div className="mt-2">
                <input
                  id="username"
                  name="username"
                  required
                  className="block w-11/12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="max-sm:mx-2">
              <div className="flex items-center justify-between">
                <label className="block text-sm font-medium leading-6 text-gray-900">
                  Password
                </label>
              </div>
              <div className="mt-2 relative">
                <input
                  id="password"
                  name="password"
                  type={passwordVisible ? "text" : "password"}
                  required
                  className="block w-11/12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
                {
                  !passwordVisible?
                  <span className="absolute top-1 right-10" onClick={()=>setPasswordVisible(true)}><VisibilityOffIcon/></span>:
                  <span className="absolute top-1 right-10" onClick={()=>setPasswordVisible(false)}><VisibilityIcon/></span>
                }
              </div>
            </div>

            <div className="max-sm:mx-2">
              <button
                type="submit"
                className="flex w-11/12 justify-center rounded-md bg-orange-500 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-orange-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 border-none focus-visible:outline-orange-600"
              >
                Sign in
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    </>
  )
}

export default LoginForm;

